import { MouseEventHandler } from "react";
import styles from "./index.module.scss";
import { Loading } from "@/components";
import clsx from "clsx";

type PrimaryButtonProps = {
  className?: string;
  style?: object;
  icon?: any;
  text: string;
  loading?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>
}

const PrimaryButton = (props: PrimaryButtonProps) => {
  const {
    className,
    style = {},
    icon,
    text,
    loading,
    onClick,
  } = props;

  return (
    <button
      style={style}
      className={clsx(
        styles["primary_button"],
        className,
      )}
      disabled={loading}
      onClick={onClick}
    >
      {loading ? (
        <Loading></Loading>
      ) : (
        <>
          {icon && (
            <span
              className={styles["icon_wrapper"]}
            >
              {icon}
            </span>
          )}
        </>
      )}
      <span>{text}</span>
    </button>
  )
}

export default PrimaryButton;